import React from 'react';
import Svg, { Path, Line, Polyline } from 'react-native-svg';
import { AdminColors } from '../../constants/adminColors';

export const EditIcon = () => (
  <Svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={AdminColors.gray400} strokeWidth="2">
    <Path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <Path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </Svg>
);

export const DeleteIcon = () => (
  <Svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={AdminColors.gray400} strokeWidth="2">
    <Polyline points="3 6 5 6 21 6" />
    <Path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  </Svg>
);

export const PlusIcon = () => (
  <Svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={AdminColors.textOnDark} strokeWidth="2">
    <Line x1="12" y1="5" x2="12" y2="19" />
    <Line x1="5" y1="12" x2="19" y2="12" />
  </Svg>
);
